import i18next from 'i18next'
import { updateCurrentUser } from '../api'

const SUPPORTED_LOCALES: Locale[] = ['en', 'fr']

// Normalizes i18next's active language (e.g. "fr-FR") to a supported locale,
// defaulting to English.
export const activeLocale = (): Locale => {
  const language = (i18next.resolvedLanguage ?? i18next.language ?? 'en').split('-')[0]

  return SUPPORTED_LOCALES.includes(language as Locale) ? (language as Locale) : 'en'
}

// Persists the language the user is currently browsing in, so that emails sent
// from the back-end are localized. Best-effort: never blocks the auth flow.
export const persistUserLocale = async (user?: User): Promise<void> => {
  const locale = activeLocale()

  if (user?.locale === locale) return

  try {
    await updateCurrentUser({ locale })
  }
  catch {
    // The locale is a non-critical preference; ignore transient failures.
  }
}
